import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ModelSchemaQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ModelSchemaQuery = { __typename?: 'Query', configuratorModelSchema?: string | null | undefined };


export const ModelSchemaDocument = gql`
    query ModelSchema {
  configuratorModelSchema
}
    `;

/**
 * __useModelSchemaQuery__
 *
 * To run a query within a React component, call `useModelSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelSchemaQuery(baseOptions?: Apollo.QueryHookOptions<ModelSchemaQuery, ModelSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelSchemaQuery, ModelSchemaQueryVariables>(ModelSchemaDocument, options);
      }
export function useModelSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelSchemaQuery, ModelSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelSchemaQuery, ModelSchemaQueryVariables>(ModelSchemaDocument, options);
        }
export type ModelSchemaQueryHookResult = ReturnType<typeof useModelSchemaQuery>;
export type ModelSchemaLazyQueryHookResult = ReturnType<typeof useModelSchemaLazyQuery>;
export type ModelSchemaQueryResult = Apollo.QueryResult<ModelSchemaQuery, ModelSchemaQueryVariables>;